<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.88 17.15" style="width: 100%">
        <g id="Capa_2" data-name="Capa 2">
            <path class="cls-1"
                  d="M4.66,11.48h9a2.19,2.19,0,0,0,2.18-2.19V5.42a.4.4,0,0,0-.24-.36.5.5,0,0,0-.18-.27l-.07,0-.07,0a.48.48,0,0,0-.2,0L3.94,3.13V1.55a.53.53,0,0,0-.08-.24l-.09-.1a.45.45,0,0,0-.25-.11L1.1.07a.76.76,0,0,0-.61,0A.8.8,0,0,0,.07.47a.75.75,0,0,0,0,.62.78.78,0,0,0,.4.42l2,.85v9.77A2.19,2.19,0,0,0,4,14.19a2.09,2.09,0,0,0-.12.69.67.67,0,0,0,0,.2A2.17,2.17,0,0,0,6,17.15h.1a2.16,2.16,0,0,0,1.5-.71,2.12,2.12,0,0,0,.56-1.54,2.47,2.47,0,0,0-.08-.6h3.1a1.77,1.77,0,0,0-.08.6,2.17,2.17,0,1,0,2.16-2.16H4.66A.63.63,0,0,1,4,12.11v-.72A1.94,1.94,0,0,0,4.66,11.48Zm8,3.45a.62.62,0,0,1,.6-.6.61.61,0,0,1,.43.18.58.58,0,0,1,.16.32s0,.06,0,.09a.56.56,0,0,1-.16.43.61.61,0,0,1-.42.19.64.64,0,0,1-.43-.18A.63.63,0,0,1,12.68,14.93Zm-7.26,0a.62.62,0,0,1,.6-.6H6a.59.59,0,0,1,.59.5s0,.06,0,.09a.56.56,0,0,1-.16.43.65.65,0,0,1-.42.19A.61.61,0,0,1,5.42,14.93Zm8.93-5.64a.65.65,0,0,1-.63.63h-9a.63.63,0,0,1-.62-.63V4.75l10.29,1.4Z"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: "CartIcon"
}
</script>

<style scoped>
.cls-1 {
    fill: currentColor;
}
</style>
